export const iconFontAwesomeDevicesHardwarePowerOff = (
	<i className="fa-solid fa-power-off"></i>
);
